// React
import { memo } from "react";

// UI
import { NumberField } from "ui/components/TextField/NumberField";

import DateRangeRentPicker from "./DateRangeRentPicker";
import { RentPeriodFieldsProps } from "./types";

/**
 * Razdoblje najma + mjesečna cijena — razdoblje se bira jednom kontrolom (kalendar od-do ili
 * gotovo trajanje), a trajanje u mjesecima se iz njega izračuna, pa se ne upisuje ručno.
 */
const RentPeriodFields: React.FC<RentPeriodFieldsProps> = (props) => {
  const {
    rentStartDate,
    rentEndDate,
    rentDurationMonths,
    monthlyPrice,
    onChange,
    onMonthlyPriceChange,
    errors = {},
    disabled,
  } = props;

  return (
    <div className="flex gap-3">
      <div className="flex-1">
        <DateRangeRentPicker
          rentStartDate={rentStartDate}
          rentEndDate={rentEndDate}
          rentDurationMonths={rentDurationMonths}
          onChange={onChange}
          error={errors.rentEndDate ?? errors.rentDurationMonths}
          disabled={disabled}
        />
      </div>
      {/* Bez handlera cijena živi na stavci najma, pa se ovdje uopće ne prikazuje. */}
      {onMonthlyPriceChange && (
        <div className="max-w-[180px]">
          <NumberField
            label="Mjesečna cijena"
            name="monthlyPrice"
            onChange={onMonthlyPriceChange}
            value={monthlyPrice}
            error={errors.monthlyPrice}
            decimals={2}
            groupAppend="€"
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
};

export default memo(RentPeriodFields);
